import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
import './App.css';

import Home from './components/Home';
import Acerca from './components/Acerca';
import Contactanos from './components/Contactanos';
import DescargaApp from './components/DescargaApp';

import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Office365Login from './components/office365auth/office365login';
import NotFoundPage from './components/NotFound';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from './img/logo_red_horizontal.png';

import AliatNavBar from './components/AliatNavBar';
import Progreso from './components/Progreso';

import { saveMsToken, getMsToken } from './helper/studentMetadata';
import { isUserFromApp } from './api/index';
import { getBasePath } from './helper/publicUrl';

const basePath = getBasePath();

function App() {
    const MainContent = (props) => {
        return (<div className="portal" >
            <Container fluid>
                <Row className="justify-content-sm-center">
                    <Col md="6" style={{ backgroundColor: "var(--white-bg)" }}>
                        {/*<Col md="6">*/}
                        <AliatNavBar />

                        <Container className="justify-content-md-start login" style={{ borderRadius: "0px", backgroundColor: "#F6F6F6" }}>
                            <header style={{ marginBottom: "16px" }}>
                                <img className='logo_h ' src={logo} alt="Red Aliat" />
                                <h5 className="blue-label"><strong>Portal de Inscripción</strong></h5>
                                <Progreso />
                            </header>

                            {props.children}
                        </Container>
                    </Col>
                </Row>
            </Container>
        </div>);
    };

    const PageLayout = (props) => {
        return (
            <MainContent>
                {props.children}
            </MainContent>
        );
    };

    const ValidateUrlToken = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get('token')

        if (token) {
            saveMsToken(`${token}_MiRedAliat`);
            return true;
        }

        return false;
    };

    const CustomRouter = () => {
        //let isAuthenticated = useIsAuthenticated();

        const AuthBrowserRoter = () => {
            return <BrowserRouter basename={basePath} >
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/acerca" element={<Acerca />} />
                    <Route path="/contactanos" element={<Contactanos />} />
                    <Route path="/descarga" element={<DescargaApp />} />
                </Routes>
            </BrowserRouter>
        };

        const UnauthBrowserRouter = () => {
            return <UnauthenticatedTemplate>
                <BrowserRouter basename={basePath} >
                    <Routes>
                        <Route path="/" element={<Office365Login />} />
                        <Route path="/acerca" element={<Acerca />} />
                        <Route path="/contactanos" element={<Contactanos />} />
                        <Route path="/descarga" element={<DescargaApp />} />
                    </Routes>
                </BrowserRouter>
            </UnauthenticatedTemplate>
        };

        if (ValidateUrlToken())
            return <AuthBrowserRoter />;

        if (isUserFromApp())
            return <AuthBrowserRoter />;

        return (<>
            <AuthenticatedTemplate>
                <AuthBrowserRoter />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <UnauthBrowserRouter />
            </UnauthenticatedTemplate>
        </>);
    };

    return (
        <div className="App">
            <PageLayout>
                <CustomRouter />
            </PageLayout>
        </div>
    );
};

export default App;
